import * as B from '@blueprintjs/core';
import classNames from 'classnames';
import React from 'react';

import cs from './styles.module.scss';

interface Props {
  title: string;
  description: string;
  icon?: B.IconName;
  tag?: string;
  // Left undefined by cards that open something rather than being a choice, which also keeps
  // aria-pressed off them.
  selected?: boolean;
  disabled?: boolean;
  dashed?: boolean;
  onSelect?: () => void;
}

export const OptionCard: React.FC<Props> = ({
  title,
  description,
  icon,
  tag,
  selected,
  disabled = false,
  dashed = false,
  onSelect,
}) => (
  <button
    className={classNames(cs.optionCard, {
      [cs.optionCardIconLayout]: !!icon,
      [cs.optionCardSelected]: selected,
      [cs.optionCardDashed]: dashed,
    })}
    onClick={onSelect}
    disabled={disabled}
    aria-pressed={selected}
  >
    {icon && <B.Icon icon={icon} size={20} className={cs.optionCardIcon} />}
    <span className={cs.optionCardText}>
      <span className={cs.optionCardTitleRow}>
        <span className={cs.optionCardTitle}>{title}</span>
        {tag && <span className={cs.optionCardTag}>{tag}</span>}
      </span>
      <span className={cs.optionCardDescription}>{description}</span>
    </span>
  </button>
);
